import type { CrudApiRoutes } from '@common/defs/types';

const prefix = '/notifications';
const ApiRoutes: CrudApiRoutes = {
  CreateOne: prefix,
  ReadAll: prefix,
  ReadAllTargeted: prefix + '/targeted',
  ReadOne: prefix + '/{id}',
  UpdateOne: prefix + '/{id}',
  DeleteOne: prefix + '/{id}',
  MarkAllAsRead: prefix + '/mark-all-as-read',
  MarkOneAsRead: prefix + '/mark-as-read/{id}',
  MarkAllAsUnread: prefix + '/mark-all-as-unread',
  MarkOneAsUnread: prefix + '/mark-as-unread/{id}',
  BroadcastOne: prefix + '/{id}/broadcast',
  toggleReadOne: prefix + '/{id}/toggle',
};

export default ApiRoutes;
